// Path: ./src/app/pages/StoreUploadedImagePage/styled.ts
import styled from "styled-components";

export const LeftButtonSection = styled.div``;

export const TableWrapper = styled.div`
  padding-left: 20px;
  padding-right: 20px;
`;
